import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdateDocumentPayor() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.updateDocumentPayorDocumentsKeyPayorPutMutation(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.path.key },
        }),
      )
      queryClient.invalidateQueries(
        apiClient.getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetOptions({
          path: { key: variables.path.key },
        }),
      )
    },
  })
}
